import * as React from "react";
import {translate} from "react-i18next";
import i18n from "i18next";
import {Header} from "../../components/Header";
import TextBody from "../../components/TextBody";
import {Container, Row, Col} from "reactstrap";
import BottomBar from "../../components/BottomBar";
import TopNav from "../../components/TopNav";
import {formatDateForBottomBar, getWeekdayFromDate} from "../../DateHelper";
import TextField from '@material-ui/core/TextField';
import "../../vodafone.css"
import {SpacerRow} from "../../components/SpacerRow";
import SubPageTopBar from "../../components/SubPageTopBar";
import {BrowserView,MobileView,isMobile} from "react-device-detect";
import vodafoneLogo from "../../media/icons/vf-logo.png";


class Stage3PreviousTenant extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            firstName: props.previousTenant ? props.previousTenant.firstName : "",
            lastName: props.previousTenant ? props.previousTenant.lastName: "",
        }
    }

    buildStateForParent = () => {
        return {
            firstName: this.state.firstName,
            lastName: this.state.lastName
        }
    };

    render() {
        let bottomBarMainButtonTextResource;
        let bottomBarMainButtonActiveColor;
        if(this.state.firstName && this.state.firstName.length > 0 || this.state.lastName && this.state.lastName.length > 0){
            bottomBarMainButtonTextResource = "continue"
            bottomBarMainButtonActiveColor = true
        }else{
            bottomBarMainButtonTextResource = "skip"
            bottomBarMainButtonActiveColor = false
        }

        const bottomBarElement = <BottomBar
            mainButtonOnClick={() => {
                this.props.previousTenantSelectCallback(
                    this.buildStateForParent()
                )
            }}
            mainButtonTextResource={bottomBarMainButtonTextResource}
            mainButtonIsActiveColor={bottomBarMainButtonActiveColor}
            backButtonOnClick={() => {
                this.props.previousStep(this.buildStateForParent())
            }}
            additionalText={"weekday_date"}
            showFullWidth={true}
            weekday={
                getWeekdayFromDate(this.props.date)
            }
            date={
                formatDateForBottomBar(this.props.date)
            }
        />;

        const pageContent = <div>
            <SubPageTopBar
                progress={2}
                onClickClose={this.props.onClickClose}
            />
            <SpacerRow/>
            <Row>
                <Col xs={12}>
                    <Header textResource={"previous_tenant_title"}/>
                </Col>
            </Row>
            <SpacerRow/>
            <Row>
                <Col xs={12}>
                    <TextBody
                        textResource={"previous_tenant_body"}
                    />
                </Col>
            </Row>
            <SpacerRow/>
            <Row>
                <Col xs={12} className={"margin-16"}>
                    <TextField
                        className={"width-100"}
                        type={"text"}
                        inputProps={{
                            maxLength: '1000',
                            minLength: '3'
                        }}
                        label={i18n.t("first_name")}
                        placeholder={i18n.t("first_name")}
                        value={this.state.firstName}
                        onChange={(event) => {
                            this.setState({firstName: event.target.value})
                        }}
                    />
                </Col>
                <Col xs={12} className={"margin-16"}>
                    <TextField
                        className={"width-100"}
                        type={"text"}
                        inputProps={{
                            maxLength: '1000'
                        }}
                        label={i18n.t("last_name")}
                        value={this.state.lastName}
                        onChange={(event) => {
                            this.setState({lastName: event.target.value})
                        }}
                    />
                </Col>
            </Row>
        </div>;

		/**
		 * Top Navigation / "Footer" Link
		 */
		const footerLnk = <TopNav
			buttonTextResource={"footer_link"}
			buttonOnClick={this.props.openTopNav}
		/>;

        return <Container fluid={true} style={{height:"100%",backgroundColor:"white"}}>
            <MobileView>
                <Row>
                    <Col xs={2} style={{marginTop:"15px"}}>
                        <img src={vodafoneLogo} className={"img-fluid"}  alt={"Vodafone Logo"}/>
                    </Col>
                    {footerLnk}
                </Row>
                {pageContent}
                <span className={"fixed-to-bottom fixed-to-bottom-nomargin"}>
                    {bottomBarElement}
                </span>
            </MobileView>
            <BrowserView>
                <Container>
                    <Row>
                    {footerLnk}
                    </Row>
                    <Row>
                        <Col sm={{ size: 8, offset: 2 }} md={{ size: 6, offset: 3 }} lg={{ size: 4, offset: 4 }}>
                            {pageContent}
                            {bottomBarElement}
                        </Col>
                    </Row>
                </Container>
            </BrowserView>
        </Container>
    }
}

export default translate("translations")(Stage3PreviousTenant);